import { render, staticRenderFns } from "./MatchAnnoPanel.vue?vue&type=template&id=0e839ffa&scoped=true"
import script from "./MatchAnnoPanel.vue?vue&type=script&lang=js"
export * from "./MatchAnnoPanel.vue?vue&type=script&lang=js"
import style0 from "./MatchAnnoPanel.vue?vue&type=style&index=0&id=0e839ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e839ffa",
  null
  
)

export default component.exports